import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import './skeleton';

// Livewire 4 đã bundle Alpine + persist, focus, collapse, intersect (x-intersect)...
// KHÔNG đăng ký lại plugin đó — "Cannot redefine property" → Alpine crash, x-cloak không gỡ.
Livewire.start();
